module.exports = __webpack_public_path__ + "img/冯寸生.d85b61fb.jpg";